/*******************************************************************************
  InspectionDetailsBox.js

  Author: Advait; 

*******************************************************************************/
import React from "react";
import "../index.css";

function InspectionDetailsBox(props) {
  return (
    <div className="inspection-details" data-testid="inspection-details">
      {Object.keys(props.inspectionData).length === 0 ? (
        <div>No inspection data available</div>
      ) : (
        Object.entries(props.inspectionData).map(([key, value]) => (
          <div key={key}>
            {key}: {value}
          </div>
        ))
      )}
    </div>
  );
}
export default InspectionDetailsBox;
